<template>
  <div
    v-if="normalizedManifestTransports && normalizedManifestTransports.length > 0"
  >
    <v-row>
      <v-col
        cols="12"
      >
        <v-card-title>
          <span style="color: #0074BA">運搬終了報告</span>&emsp;
        </v-card-title>
        <v-card
          flat
          class="rounded-card"
          v-for="manifest_transport in normalizedManifestTransports"
          :key="manifest_transport.section"
        >
          <v-card-text>
            <v-card-subtitle class="subtitle-1 font-weight-bold">区間{{ manifest_transport.section }}</v-card-subtitle>
            <!-- 報告担当者/運搬担当者/運搬終了日/車両番号 -->
            <v-row>
              <v-col cols="12" md="3">
                <div class="overline">
                  報告担当者
                </div>
                <h4>
                  {{ manifest_transport.transport_end_report.report_reporter_name || '-' }}&nbsp;
                </h4>
                <v-divider />
              </v-col>
              <v-col cols="12" md="3">
                <div class="overline">
                  運搬担当者
                </div>
                <h4 v-if="manifest_transport.transport_end_report.transport_name">
                  {{ manifest_transport.transport_end_report.transport_name || '-' }}&nbsp;
                </h4>
                <h4 v-else>
                  {{ '-' }}
                </h4>
                <v-divider />
              </v-col>
              <v-col cols="12" md="3">
                <div class="overline">
                  運搬終了日
                </div>
                <h4 v-if="manifest_transport.transport_end_report.report_transport_completed_date">
                  {{ manifest_transport.transport_end_report.report_transport_completed_date | date_format }}&nbsp;
                </h4>
                <h4 v-else>
                  {{ '-' }}
                </h4>
                <v-divider />
              </v-col>
              <v-col cols="12" md="3">
                <div class="overline">
                  車両番号
                </div>
                <h4>
                  {{ manifest_transport.transport_end_report.report_vehicle_number || '-' }}&nbsp;
                </h4>
                <v-divider />
              </v-col>
            </v-row>
            <!-- 運搬量/有価物拾集量/運搬備考/運搬備考 -->
            <v-row>
              <v-col cols="12" md="3">
                <div class="overline">
                  運搬量
                </div>
                <h4 v-if="manifest_transport.transport_end_report.report_transport_quantity && manifest_transport.transport_end_report.report_transport_quantity_unit_name">
                  {{ manifest_transport.transport_end_report.report_transport_quantity }}&nbsp;{{ manifest_transport.transport_end_report.report_transport_quantity_unit_name }}
                </h4>
                <h4 v-else>
                  {{ '-' }}
                </h4>
                <v-divider />
              </v-col>
              <v-col cols="12" md="3">
                <div class="overline">
                  有価物拾集量
                </div>
                <h4 v-if="manifest_transport.transport_end_report.report_valuables_collecting_quantity && manifest_transport.transport_end_report.report_valuables_collecting_quantity_unit_name">
                  {{ manifest_transport.transport_end_report.report_valuables_collecting_quantity }}&nbsp;{{ manifest_transport.transport_end_report.report_valuables_collecting_quantity_unit_name }}
                </h4>
                <h4 v-else>
                  {{ '-' }}
                </h4>
                <v-divider />
              </v-col>
              <v-col cols="12" md="6">
                <div class="overline">
                  運搬備考
                </div>
                <h4>
                  {{ manifest_transport.transport_end_report.report_note || '-' }}&nbsp;
                </h4>
                <v-divider />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'TransportReportResult',
  components: {},
  mixins: [],
  props: {
    /**
     * マニフェスト詳細
     */
     manifestTransports: {
      type: [Array, Object],
      default: () => []
    },
  },
  data() {
    return {
    }
  },
  computed: {
    normalizedManifestTransports() {
      if (!this.manifestTransports) {
        return []
      }
      // 配列の場合はそのまま返す
      if (Array.isArray(this.manifestTransports)) {
        return this.manifestTransports
      }
      // オブジェクトの場合は配列に変換
      if (typeof this.manifestTransports === 'object') {
        return [this.manifestTransports]
      }
      return []
    }
  },
  watch: {},
  created() {
  },
  methods: {
  }
}
</script>
